import React from 'react';
import icon from 'src/assets/images/datax/file-text.png'
import { styled } from '@superset-ui/core';

interface Props {
    title: string;
    rightElement: JSX.Element;
}

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 1.5rem 1.7rem;
`;

const TextRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
`;

const Title = styled.div`
    display: flex;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 1.8rem;
`;

const Header = (props: Props) => {
    return (
        <Container>
            <TextRow>
                <img src={icon} alt="icon" />
                <Title>{props.title}</Title>
            </TextRow>
            {props.rightElement}
        </Container>
    );
};

export default Header;